<template>
  <table class="table table-custom table-hover mt-4">
    <!-- Header -->
    <thead>
      <tr class="table-header text-center">
        <th class="w-15 align-middle">
          Número do pedido
        </th>
        <th class="w-25 align-middle">
          Data e hora de cumprimento
        </th>
        <th class="w-25 align-middle">
          Usuário que cumpriu o pedido
        </th>
        <th class="w-15 align-middle">
          Módulo
        </th>
        <th class="w-10 align-middle">
          Número da OS
        </th>
        <th class="w-10 align-middle">
          Link certidão eletrônica
        </th>
      </tr>
    </thead>

    <!-- Body -->
    <tbody>
      <tr v-for="pedido in pedidos"
          :key="pedido.id"
          class="text-center">
        <td class="w-15">
          {{ pedido.pedido_certidao_id || '-' }}
        </td>
        <td class="w-25">
          {{ formatarDataHora (pedido.data_cumprimento) }}
        </td>
        <td class="w-25">
          {{ pedido.nome_usuario || '-' }}
        </td>
        <td class="w-15">
          {{ pedido.modulo || '-' }}
        </td>
        <td class="w-10">
          <router-link
            v-if="pedido.numero_ordem_servico"
            :to="{
              name: 'ordem_servico_editar',
              params: { id: pedido.ordem_servico_id }
            }">
            {{ pedido.numero_ordem_servico }}
          </router-link>

          <span v-else>-</span>
        </td>
        <td class="w-10">
          <a v-if="pedido.id_verificador_certidao"
             :href="`https://certidaoh.registrocivil.org.br/validar/${pedido.id_verificador_certidao}`"
             target="_blank">Acessar</a>

          <span v-else>-</span>
        </td>
      </tr>

      <!-- Linha exibida quando não há pedidos cumpridos para mostrar -->
      <tr v-if="pedidos.length === 0">
        <td colspan="6">
          Nenhum pedido encontrado.
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "TabelaPedidos",
    props: {
      pedidos: {
        type: Array,
        required: true
      }
    },
    methods: {
      formatarDataHora (data) {
        return data ? moment(data).local().format('DD/MM/YYYY - HH[h]mm') : '-'
      }
    }
  }
</script>

<style>
  .table-custom {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
    table-layout: fixed;
  }

  .table-header {
    font-weight: bold;
    padding: 10px;
    background-color: #00C0A7;
  }

  td a {
    white-space: normal;
    word-break: break-word;
  }
</style>
